module.exports = __webpack_public_path__ + "media/stylesheets/images/Mediros Stephen Yoshihiro-6f2377745b51b6a07e8d4eedf4a07015.jpg";